export default __webpack_public_path__ + "static/media/2.31bfa232.jpg";